import React from 'react'
import {Grid} from '@mui/material'
import Section from './Section'
import LoadingIndicator from '../../shared/UI/LoadingIndicator'
import {SectionConfig} from './types'
// eslint-disable-next-line import/extensions
import { LoadingIndicatorContainer, ChartContainer } from './ReportContent.styles'

interface ReportContentProps {
  isLoading: boolean;
  sections: SectionConfig[];
  isEditMode: boolean;
  hiddenSections: string[];
  onMoveUp: (id: string) => void;
  onMoveDown: (id: string) => void;
  onToggleVisibility: (id: string) => void;
}

function ReportContent({
  isLoading,
  sections,
  isEditMode,
  hiddenSections,
  onMoveUp,
  onMoveDown,
  onToggleVisibility
}: Readonly<ReportContentProps>): JSX.Element {
  if (isLoading) {
    return (
      <LoadingIndicatorContainer>
        <LoadingIndicator show={isLoading} />
      </LoadingIndicatorContainer>
    )
  }

  return (
    <ChartContainer>
      <Grid container spacing={3}>
        {sections.map((section, index) => (
          <Grid item xs={12} key={section.id}>
            <Section
              section={section}
              isFirst={index === 0}
              isLast={index === sections.length - 1}
              isHidden={hiddenSections.includes(section.id)}
              isEditMode={isEditMode}
              onMoveUp={onMoveUp}
              onMoveDown={onMoveDown}
              onToggleVisibility={onToggleVisibility}
            />
          </Grid>
        ))}
      </Grid>
    </ChartContainer>
  )
}

export default ReportContent